//------------------------------------------------------ externos
import Swal from "sweetalert2";
//------------------------------------------------------ funciones
import { UNICOS, conflictos, textoDe } from "../../../shared/duplicados";
import { listarColeccion } from "../../../services/collections.service";

/* «Esto ya está cargado» — el paso que faltaba antes de guardar.
 *
 * VIVE ACÁ Y NO EN CADA FORMULARIO. `submitTractor`, `submitFurgon`,
 * `submitVehiculo` y `submitPersona` son cuatro funciones casi idénticas, y
 * ninguna de las cuatro chequeaba NADA: ni siquiera que el id no existiera.
 * Escrito adentro de cada una, el quinto padrón que se agregue nace sin el
 * chequeo y nadie se entera hasta que aparezca la patente repetida en un
 * reporte. Acá lo comparten las cuatro.
 *
 * LA REGLA DE QUÉ CHOCA CON QUÉ ES OTRA COSA y vive en `shared/duplicados.js`,
 * que es puro y se prueba en una tabla. Esto es sólo el cartel.
 *
 * ── EL ID BLOQUEA, EL RESTO AVISA ─────────────────────────────────────────
 *
 * No es la misma pregunta y por eso no salen por la misma puerta:
 *
 *   · EL ID YA EXISTE → se corta. `createTractor` con un id repetido pisa o
 *     rebota, y las dos cosas son peores que no dejar guardar: en un caso se
 *     pierde una fila y en el otro sale un error crudo que no dice qué pasó.
 *   · LA PATENTE YA ESTÁ EN OTRO INTERNO → se avisa con cuál, y decide la
 *     persona. No pisa nada, y es lo que pasa el día que una chapa se pasa de
 *     una unidad a otra. Misma regla que `mecanicos.parecidos()`.
 *
 * ── Y SI NO SE PUDO MIRAR, NO SE FRENA ────────────────────────────────────
 *
 * Un padrón que no contesta no puede convertirse en «no podés cargar»: el
 * síntoma sería que nadie carga nada y el motivo no estaría escrito en ningún
 * lado. Se dice que NO SE PUDO VERIFICAR, que es distinto de decir que está
 * libre — misma distinción que hace `ficha.py` entre «no lo encontré» y «no
 * pude fijarme».
 *
 * Devuelve `true` si se puede seguir.
 */
export async function sePuedeGuardar({
  coleccion,
  formData,
  idNuevo,
  modoEdicion,
  idActual = null,
}) {
  let filas;
  try {
    filas = await listarColeccion(coleccion);
  } catch (e) {
    console.warn("[duplicados] no se pudo verificar:", e);
    const r = await Swal.fire({
      title: "No se pudo verificar",
      text: "No pude fijarme si esto ya está cargado. Eso no quiere decir que esté libre: no lo pude mirar.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Guardar igual",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#4161bd",
    });
    return r.isConfirmed;
  }

  /* El id sólo se chequea al CREAR. Editando, el id es el de la fila que se
   * está tocando y chocaría siempre consigo mismo. */
  if (!modoEdicion) {
    const clave = String(idNuevo ?? "").trim();
    const ya = (filas || []).find((f) => String(f?.id ?? "") === clave);
    if (ya) {
      await Swal.fire({
        title: "Ese número ya existe",
        /* Con QUIÉN choca, no sólo que choca. «Ya existe» a secas obliga a ir
         * a buscarlo a mano, y lo más probable es que no se busque. */
        text:
          `El ${clave} ya está cargado` +
          (ya.dominio ? ` (${ya.dominio})` : "") +
          ". Si es otra unidad, va con otro número.",
        icon: "error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#4161bd",
      });
      return false;
    }
  }

  if (!UNICOS[coleccion]?.length) return true;

  const choques = conflictos(coleccion, formData, filas, idActual);
  if (!choques.length) return true;

  const r = await Swal.fire({
    title: "Puede que ya esté cargado",
    text: `${textoDe(choques)} ¿Lo guardo igual?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Guardar igual",
    cancelButtonText: "Revisar",
    // El botón que NO escribe va enfocado: el que llega a este cartel casi
    // siempre se equivocó de número, no está confirmando una decisión.
    focusCancel: true,
    confirmButtonColor: "#4161bd",
  });
  return r.isConfirmed;
}
